import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const _stored = typeof localStorage !== "undefined" ? localStorage.getItem("rawaj_token") : null;
if (_stored) api.defaults.headers.common["Authorization"] = `Bearer ${_stored}`;

export function setAuthToken(access, refresh) {
  if (access) {
    localStorage.setItem("rawaj_token", access);
    api.defaults.headers.common["Authorization"] = `Bearer ${access}`;
  }
  if (refresh) localStorage.setItem("rawaj_refresh", refresh);
}

export function clearAuthToken() {
  localStorage.removeItem("rawaj_token");
  localStorage.removeItem("rawaj_refresh");
  delete api.defaults.headers.common["Authorization"];
}

export const MAINTENANCE_MSG = "نحدّث رواج الذكية الحين، لحظات وترجع. حاول بعد دقيقة";

let refreshing = null;
let onUnauthorized = null;
export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}
let onPaymentRequired = null;  // 402 = لا رصيد/اشتراك — تُعرض نافذة الإرشاد (الباقات والأرصدة + أدلة الاستخدام) بدل رسالة خطأ فقط
export function setPaymentRequiredHandler(fn) {
  onPaymentRequired = fn;
}

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    if (status === 402 && onPaymentRequired) onPaymentRequired(error.response?.data?.detail);
    // Ride out brief server restarts (deploys, pod recycles): retry reads on network errors / 502-504.
    const transient = !error.response || [502, 503, 504].includes(status);
    if (transient && original && (original.method || "get").toLowerCase() === "get" && (original._tries || 0) < 4) {
      original._tries = (original._tries || 0) + 1;
      await new Promise((r) => setTimeout(r, 1500 * original._tries));
      return api(original);
    }
    if (transient) {
      // Friendly message instead of the generic error while the server restarts.
      error.response = { ...(error.response || {}), status: status || 503, data: { detail: MAINTENANCE_MSG } };
    }
    if (status === 402 && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("rawaj:subscribe", { detail: error.response?.data?.detail }));
    }
    const skip =
      url.includes("/auth/refresh") || url.includes("/auth/login") ||
      url.includes("/auth/register") || url.includes("/auth/logout");
    if (status === 401 && original && !original._retry && !skip) {
      original._retry = true;
      try {
        refreshing = refreshing ||
          api.post("/auth/refresh", { refresh_token: localStorage.getItem("rawaj_refresh") });
        const res = await refreshing;
        refreshing = null;
        if (res?.data?.access_token) setAuthToken(res.data.access_token, res.data.refresh_token);
        return api(original);
      } catch (e) {
        refreshing = null;
        clearAuthToken();
        if (onUnauthorized) onUnauthorized();
      }
    }
    return Promise.reject(error);
  },
);

export function formatError(detail) {
  if (detail == null) return "حدث خطأ ما، حاول مرة أخرى.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
export { API };
